import React from 'react'
import { Redirect } from 'react-router-dom'
import adminRoutesConstant from '../../../../constants/adminRoutesConstant'

const RenderAdminByPermission = ({
    auth
}) => {
    if (auth.admin && auth.admin.jwt) {
        let nextPageUrl = ''

        // 1. get the list of all allowed urls
        const urlList = Object.values(adminRoutesConstant.adminPaths).filter(each => !!auth.admin.permission[each.permissionKey])

        // 2. get the list of all urls that are shown in sidebar
        const allowedSidebarUrls = urlList.filter(each => each.isShownOnSidebar)

        // 3. if it has access to sidebar link send the user to the first sidebar link
        if (allowedSidebarUrls.length > 0) {
            for (let i = 0; i < allowedSidebarUrls.length; i++) {
                const allowedUrlObj = allowedSidebarUrls[i];
                nextPageUrl = allowedUrlObj.url();
                break;
            }
        }
        // 4. if ther user does not have access to sidebar link then send the user to whichever the first link is available
        else {
            for (let i = 0; i < urlList.length; i++) {
                const allowedUrlObj = urlList[i];
                nextPageUrl = allowedUrlObj.url();
                break;
            }
        }

        //5 if nothing is available send the user to dashboard (but it will technically show a blank screen)
        // change this to user account page later
        nextPageUrl = !!nextPageUrl ? nextPageUrl : adminRoutesConstant.adminUrls.AdminDashboardScreen.url()

        console.log('sending to', nextPageUrl)
        return <Redirect to={nextPageUrl} />
    }
    return null
}

export default RenderAdminByPermission
